var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-container"},[_c('div',{staticClass:"info-header"},[_c('div',{staticClass:"info-header-title"},[_vm._v(_vm._s(_vm.showLang('com.data.statistics')))])]),(_vm.isShowAnalysis)?_c('div',{staticClass:"info-body"},[_c('div',{staticClass:"info-body-count"},[_c('AnalysisPowerTable',{staticClass:"count-table"})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }